// Thông tin pháp lý dùng chung cho Privacy Policy + Điều khoản sử dụng.
// Đổi email/tên đơn vị tại đây khi có thông tin chính thức (Google verification
// yêu cầu email liên hệ THẬT, có người đọc).
export const LEGAL = {
	appName: 'Omni SEO',
	// Domain chính đã verify với Google (dùng trong nội dung chính sách).
	domain: 'omni-seo.vn',
	contactEmail: 'huutrong.it93@gmail.com',
	// Ngày hiệu lực — cập nhật mỗi lần sửa nội dung chính sách.
	effectiveDate: '06/07/2026',
};
